import HotelCardAvailability from './HotelCardAvailability';

export default HotelCardAvailability;
